module.exports = __webpack_public_path__ + "static/media/tradehub.96425e2e.jpg";